const caindoNaLua = {
  title: "SABOR DO SOM",
  date: '19/11/2023',
  content: `Música e Gastronomia: O Sabor do Som  

Eu amo música.  
Mas também amo comer e beber.  
Por isso, gosto de fazer este paralelo entre música e gastronomia:  

Imagine que os artistas e bandas são restaurantes, os álbuns são os cardápios e as músicas são os pratos que estão sendo servidos.  

A música de hoje é como aqueles pratos feitos servidos em várias esquinas na hora do almoço:  
Muitos são bons, outros nem tanto, mas eles atingem seu propósito:  
Matam sua fome.  
E nada além disso.  

Eles estão ali apenas para preencher um espaço:  
Um espaço na sua barriga e na sua hora livre do dia.  

Assim como as músicas de hoje estão ali apenas para preencher uma trilha de um filme ou série,  
O plano de fundo de uma festa,  
Uma dança de TikTok,  
Ou o som que precisa existir no carro para não ficar aquele silêncio total durante a viagem.  

Os pratos desses restaurantes não são necessariamente ruins, muitos têm substância e são feitos de forma competente.  
Hoje temos produções musicais de altíssimo nível, os melhores instrumentos, os timbres mais bonitos de se ouvir, mixagens inspiradas e sem erros.  

Só que, quando você quer levar seus amigos para algum lugar especial, dificilmente cogita esse restaurante de bairro,  
Pois sabe que nada ali será memorável.  

Porque, no fundo, você sabe que essas músicas não são diferentes das outras, tampouco originais, e por isso não são memoráveis.  

Elas são assim porque são receitas muito bem pensadas, feitas com o único propósito de você sempre voltar lá na hora do almoço, quando quiser matar a fome.  

São feitas por uma fórmula que precisa ter as mesmas harmonias, melodias e os mesmos tipos de letras que grudam na cabeça.  

Mas você sabe que, meses depois, não vai virar para um amigo e, em uma conversa despretensiosa, subitamente mudar de assunto para relembrar aquele prato gostoso, como aquela receita era diferente e como o preço justificava sua qualidade.  

Você só faz isso quando uma música te marca de forma particular.  
Esse prato não precisa ter todos os elementos para ser memorável.  

Não precisa ter uma poesia complexa, uma harmonia extravagante ou uma melodia extremamente inspirada,  
Mas precisa ter algo diferente,  
Ter um sabor único que raramente se encontra em outro artista.  

Algo que marque aquele restaurante e faça você não pensar em ir a nenhum outro quando quiser sentir aquele mesmo sabor.  

Mas isso não acontece porque são tantos restaurantes competindo que, se você não fizer algo realmente único, você será apenas mais um entre muitos.  
E, no fim, a maioria das pessoas não se lembra de mais um.  

O problema não é a existência desses pratos feitos, dessas músicas rápidas e eficientes. Elas têm seu lugar, cumprem seu papel.  
O problema é quando quase tudo se resume a isso,  
Quando a música deixa de ser uma experiência marcante para ser apenas uma necessidade rotineira,  
Como um almoço apressado entre compromissos.  

Os grandes chefs não se preocupam apenas em alimentar.  
Eles querem provocar sensações, criar memórias, surpreender com combinações inesperadas.  
E os grandes artistas fazem o mesmo.  
Não estão apenas preenchendo o silêncio,  
Estão criando sons que você quer revisitar,  
Que ficam ecoando na sua mente mesmo depois da última nota.  

Afinal, você não lembra de todas as refeições que já fez na vida.  
Mas aquelas que te surpreenderam, que tinham algo especial, que despertaram algo em você,  
Essas, sim, ficam para sempre.  

E com a música deveria ser igual.  

Por isso, quando você for atrás de algo novo para ouvir, talvez valha a pena procurar não apenas pelo que mata a fome,  
Mas pelo que realmente deixa um gosto que vale a pena lembrar.`
};

export default caindoNaLua;
